import React, { Component } from 'react';
import App_data from '../../config/App_data';
import { browserHistory } from 'react-router';


class Cfa3EssayQuesPdf extends Component {
  constructor(props) {
    super(props); 
    this.state={
      pdfurl:''
    }   
  }


  componentDidMount()
  {       
    // console.log('workingh')
    // console.log(this.props.location.state.pdffilename)
    var storage_session=JSON.parse(localStorage.getItem('localstorageval'));
    if(storage_session)
    {
      // console.log('oif working')
      this.setState({pdfurl:this.props.location.state.pdffilename});
    }
    else{
      localStorage.removeItem('localstorageval');
      localStorage.removeItem('selectedmenu', '');
      browserHistory.push('/');
    }
  }

  render() {
  
    return (
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12 text-center margin_bottom_20 logo_wrapper">
           <div>            
            <object data={App_data.frontend_url+"/pdf/cfa3EssayQuesPdf/"+this.state.pdfurl} 
            type="application/pdf"  style={{height: 100 + 'vh', width: 100 + '%'}}></object>
          </div>
           
          </div>
        </div>
        
      </div>
    );
  }
}

export default Cfa3EssayQuesPdf;



// WEBPACK FOOTER //
// ./src/views/Pages/Cfa3EssayQuesPdf/Cfa3EssayQuesPdf.js